import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import BrandLogo from "../components/shared/BrandLogo";

const PAGE = "min-h-[100dvh] pb-[env(safe-area-inset-bottom)] bg-[#f4f8fc] dark:bg-[#050d1e]";

export default function RequestSent() {
  return (
    <div className={`${PAGE} flex flex-col items-center justify-center px-4`}
      style={{ paddingTop: "env(safe-area-inset-top)" }}
    >
      <div className="w-full max-w-md animate-in fade-in zoom-in duration-300">

        {/* Wordmark */}
        <div className="text-center mb-7">
          <BrandLogo variant="auto" className="w-14 h-14 mx-auto mb-2.5 object-contain" />
          <h1 className="text-[22px] font-bold text-brand dark:text-blue-400 tracking-tight">Kéves App</h1>
          <p className="text-[12px] text-slate-400 dark:text-slate-500 mt-1">Solicitud de acceso</p>
        </div>

        {/* Card */}
        <div className="bg-white dark:bg-slate-900 rounded-[28px] shadow-[0_4px_24px_rgba(0,0,0,0.08)] dark:shadow-[0_8px_32px_rgba(0,0,0,0.4)] border border-slate-100 dark:border-slate-800 p-6 text-center space-y-4">

          <div className="h-16 w-16 rounded-[20px] bg-emerald-50 dark:bg-emerald-900/20 flex items-center justify-center mx-auto shadow-sm">
            <CheckCircle2 size={30} className="text-emerald-600 dark:text-emerald-400" />
          </div>

          <div>
            <h2 className="text-[18px] font-bold text-slate-800 dark:text-slate-100 mb-1">Solicitud enviada</h2>
            <p className="text-[13px] text-slate-500 dark:text-slate-400 leading-relaxed">
              Tu solicitud fue recibida correctamente.
              En breve un administrador revisará tu acceso.
            </p>
          </div>

          <p className="text-[12px] text-slate-400 dark:text-slate-500 leading-relaxed">
            Cuando el administrador apruebe tu solicitud, recibirás un correo con un enlace para crear tu contraseña.
          </p>

          <Link
            to="/login"
            className="flex items-center justify-center w-full h-12 bg-brand text-white rounded-[14px] font-semibold text-[15px] shadow-sm transition-all duration-200 hover:brightness-105 active:scale-[0.98]"
          >
            Volver al inicio
          </Link>

        </div>

      </div>
    </div>
  );
}
